import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
const API = process.env.REACT_APP_API_URL || '';

export default function ElokuvaPage({ event }) {
  const [movie, setMovie] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const id = event?.movieId || event?.movie_id;
    if (!id) {
      setMovie(null);
      return;
    }
    setLoading(true);
    fetch(`${API}/api/movies/${encodeURIComponent(id)}`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data && typeof data === 'object') {
          setMovie(data);
        } else {
          setMovie(null);
        }
      })
      .catch(() => {
        setMovie(null);
      })
      .finally(() => setLoading(false));
  }, [event?.movieId, event?.movie_id]);

  const title = event?.title || 'Elokuva';
  const movieName = movie?.movieName || title;
  const description = movie?.description || '';
  const coverUrl = movie?.coverUrl;
  const durationMinutes = movie?.movieLength ? Math.round(parseInt(movie.movieLength) / 60) : null;
  const imdbRating = movie?.imdbRating ?? movie?.imdb_rating ?? event?.imdbRating ?? null;

  function addMinutesToTime(startTime, duration) {
    const [hours, minutes] = startTime.split(":").map(Number);
  
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes + duration);
    date.setSeconds(0);
  
    return date.toTimeString().slice(0, 5); // returns HH:MM
  }

  return (
    <div className="ElokuvaPage">
      <div className='ElokuvaPage-event-info'>

      <p className="ElokuvaPage-event-info-text">
        {event?.eventType === 'movie' ? 'Elokuva' : '—'}tapahtuma {event.time} - {addMinutesToTime(event.time, event.minutes)} </p>

      </div>
      <div className="ElokuvaPage-main">
        {coverUrl && (
          <div className="ElokuvaPage-cover-wrap">
            <img src={coverUrl} alt={movieName} className="ElokuvaPage-movie-cover" />
          </div>
        )}
        <div className="ElokuvaPage-info">
          <h3 className="ElokuvaPage-movie-name">{movieName}</h3>
          {loading && <p className="ElokuvaPage-loading">Ladataan elokuvan tietoja…</p>}
          {description && (
            <p className="ElokuvaPage-description">
              {description}
            </p>
          )}
          <dl className="ElokuvaPage-meta">
            <div className="ElokuvaPage-meta-row">
              <dt>Elokuvan kesto</dt>
              <dd>{durationMinutes != null ? `${durationMinutes} minuuttia` : '—'}</dd>
            </div>
            <div className="ElokuvaPage-meta-row">
              <dt>Elokuvan kieli</dt>
              <dd>N/A</dd>
              </div>
              <div className="ElokuvaPage-meta-row">
              <dt>Tekstitys</dt>
              <dd>N/A</dd>
              </div>
              <div className="ElokuvaPage-meta-row">
              <dt>IMDB-arvosana</dt>
              <dd><Star size={14} fill="currentColor" strokeWidth={0} className="Tilastot-event-rating-star" aria-hidden />{imdbRating != null ? `${imdbRating} / 10` : '—'}</dd>
              </div>
          </dl>
        </div>
      </div>
    </div>
  );
}

